import { Icon } from '@chakra-ui/react';

export default function ColoredCheckCircleIcon(props) {
  return (
    <Icon
      width={18}
      height={18}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      {/* outer circle */}
      <path
        d='M88 44.3199V47.9999C87.9951 56.6256 85.202 65.0186 80.0373 71.9272C74.8727 78.8358 67.6131 83.8899 59.3414 86.3355C51.0697 88.7812 42.229 88.4875 34.1379 85.4983C26.0467 82.509 19.1386 76.9843 14.4438 69.7482C9.74907 62.5121 7.51916 53.9522 8.08671 45.3452C8.65425 36.7382 11.9888 28.5453 17.5931 21.9882C23.1974 15.4312 30.7711 10.8615 39.1848 8.96053C47.5984 7.05958 56.4011 7.92929 64.28 11.4399'
        stroke='#D5E4E7'
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      {/* check */}
      <path
        d='M88 16L48 56.04L36 44.04'
        stroke='#00A5CC'
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
}
